import React, { useEffect } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { CustomProviderTabs, CustomSMSProvider } from '../../../components';
import { Preloader, ToNavigationError } from '../../../components/ui';
import { useConfig } from '../../../contexts/config';
import { useSmsProviders } from '../../../contexts/settings';
import { RouteParams } from '../../../routes/types';

const SMSCustomProvider = ({ match }: RouteComponentProps): JSX.Element => {
  const { projectId } = match.params as RouteParams;
  const {
    getProvidersError,
    saveProvidersError,
    providersFetching,
    providersUpdateFetching,
    providersData,
    updateProviders
  } = useSmsProviders(projectId);
  const { xsollaAnalytics } = useConfig();

  useEffect(() => {
    xsollaAnalytics.sendOpen('login_pa_module__custom_sms_provider', projectId);
  }, []);

  if (providersFetching) {
    return (
      <CustomProviderTabs>
        <Preloader />
      </CustomProviderTabs>
    );
  }

  if (getProvidersError) {
    return <ToNavigationError error={getProvidersError} pageName="custom_sms_provider" />;
  }

  return (
    <CustomProviderTabs>
      <CustomSMSProvider
        providersData={providersData}
        fetching={providersUpdateFetching}
        updateProviders={updateProviders}
        submitError={saveProvidersError}
      />
    </CustomProviderTabs>
  );
};

export default withRouter(SMSCustomProvider);
